import React from "react";

function AuthField({
	id,
	label,
	error,
	hint,
	children,
	labelAction,
	className = "mb-4",
}) {
	return (
		<div className={className}>
			{(label || labelAction) && (
				<div className="mb-2 clear-both">
					{labelAction}
					{label && (
						<label
							htmlFor={id}
							className={`block text-sm font-medium text-default-800 dark:text-default-100 ${
								labelAction ? "clear-both" : ""
							}`}
						>
							{label}
						</label>
					)}
				</div>
			)}
			{children}
			{error && <p className="mt-1 text-sm text-danger">{error}</p>}
			{hint && !error && <p className="mt-1 text-sm text-default-500">{hint}</p>}
		</div>
	);
}

export default AuthField;
